import { AnimatePresence } from 'motion/react';
import React from 'react';
// import Overlay from './components/overlay/Overlay';
import { Route, Routes } from 'react-router';
import { useLocation } from 'react-router';
import Landing from './components/overlay/landing/Landing';
import TryhardMain from './components/sites/tryhard/TryhardMain';
import WeirdRoute from './components/sites/meta/WeirdRoute';
import TryhardContact from './components/sites/tryhard/Body/Page/Contact/TryhardContact';
import TryhardHome from './components/sites/tryhard/Body/Page/Home/TryhardHome';
import TryhardProducts from './components/sites/tryhard/Body/Page/Products/TryhardProducts';
import TryhardBoards from './components/sites/tryhard/Body/Page/Products/Boards/TryhardBoards';
import TryhardBoxes from './components/sites/tryhard/Body/Page/Products/Boxes/TryhardBoxes';
import EdgeMain from './components/sites/edge/EdgeMain';
import EdgeHome from './components/sites/edge/Body/Home/EdgeHome';
import EdgeProducts from './components/sites/edge/Body/Products/EdgeProducts';
import PipsMain from './components/sites/pips/PipsMain';
import PipsHome from './components/sites/pips/Body/PipsHome';
import PipsContact from './components/sites/pips/Body/PipsContact';
import PipsProducts from './components/sites/pips/Body/PipsProducts';
import PipsProductsGeneral from './components/sites/pips/Body/PipsProductsGeneral';
import PipsMysteryBag from './components/sites/pips/Body/PipsMysteryBag';
import EdgeContact from './components/sites/edge/Body/Contact/EdgeContact';
// import PipsPrefab from './components/sites/pips/Body/PipsPrefab';

const SiteRouting: React.FC = () => {
    const location = useLocation();
    const root = location.pathname.split('/')[1]

    console.log(location.pathname)

    return (
        <AnimatePresence mode='wait'>
            {/* <Overlay key='overlay' /> */}
            <Routes location={location} key={root}>
                <Route path="/" element={<Landing />} />

                <Route path="/tryhard/" element={<TryhardMain />}>
                    <Route index path='' element={<TryhardHome />} />
                    <Route index path='contact' element={<TryhardContact />} />
                    <Route path='products' element={<TryhardProducts />}>
                        <Route index path='' element={<TryhardBoards />} />
                        <Route index path='boxes' element={<TryhardBoxes />} />
                    </Route>
                </Route>

                <Route path='/pips' element={<PipsMain />}>
                    <Route index path='' element={<PipsHome />} />
                    <Route index path='contact' element={<PipsContact />} />
                    <Route path='products' element={<PipsProducts />}>
                        <Route index path='general' element={<PipsProductsGeneral />} />
                        <Route index path='mystery' element={<PipsMysteryBag />} />
                        {/* <Route index path='prefab' element={<PipsPrefab />} /> */}
                    </Route>
                </Route>

                <Route path="/edge" element={<EdgeMain />}>
                    <Route index path='' element={<EdgeHome />} />
                    <Route index path='products' element={<EdgeProducts />} />
                    <Route index path='contact' element={<EdgeContact />} />
                </Route>

                <Route path="/*" element={<WeirdRoute />} />
            </Routes>
        </AnimatePresence>
    )
}

export default SiteRouting;